/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Captcha } from '../models/Captcha';
import type { CaptchaCheckRequest } from '../models/CaptchaCheckRequest';
import { request as __request } from '../core/request';

export class CaptchaService {

    /**
     * @returns Captcha Ok
     * @throws ApiError
     */
    public static async generateCaptcha(): Promise<Captcha> {
        const result = await __request({
            method: 'GET',
            path: `/captcha/generate`,
            errors: {
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static async validateCaptcha(
        requestBody: CaptchaCheckRequest,
    ): Promise<void> {
        const result = await __request({
            method: 'POST',
            path: `/captcha/validate`,
            body: requestBody,
            errors: {
                400: `Validation Failed`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

}